import React, { useState, useEffect, useCallback } from "react";
import { useRecoilValue } from "recoil";
// @Mui
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
// atoms
import mealsCategoriesFilterAtom from "src/recoil/atoms/mealsCategoriesFilterAtom";
import userAtom from "src/recoil/atoms/userAtom";
// hooks
import useLocales from "src/hooks/useLocales";
//
import Iconify from "./Iconify";

// ----------------------------------------------------------------------------------------

function SnacksNoticePopUp() {
  const mealCategoriesFilter = useRecoilValue(mealsCategoriesFilterAtom);

  const [open, setOpen] = useState(false);

  const user = useRecoilValue(userAtom);

  const { translate } = useLocales();

  const handleClose = useCallback(() => {
    setOpen(false);
    localStorage.setItem("snacksNoticeRead", true);
  }, [setOpen]);

  useEffect(() => {
    const hasReadNotice = localStorage.getItem("snacksNoticeRead");

    if (
      mealCategoriesFilter.mealIndex === "snack" &&
      hasReadNotice !== "true"
    ) {
      setOpen(true);
    }
  }, [mealCategoriesFilter]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
      <DialogTitle sx={{ alignItems: "center", display: "inline-flex" }}>
        <Iconify
          sx={{ color: "warning.main", width: 30, height: 30, mr: 2 }}
          icon="material-symbols:info-outline"
        />
        {translate(
          "componentsTranslations.snacksNoticePopUpTranslations.title"
        )}{" "}
        {user?.first_name} {user?.last_name}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography sx={{ mt: 2 }} color="text.primary" variant="body1">
            {translate(
              "componentsTranslations.snacksNoticePopUpTranslations.description"
            )}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="outlined" onClick={handleClose}>
          {translate(
            "componentsTranslations.snacksNoticePopUpTranslations.actionButton"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SnacksNoticePopUp;
